module.exports = __webpack_public_path__ + "media/images/athletes/1202-7ce41a2b5f2df61a5e68ea079db02075.png";